const config = {
    ENDPOINT: '/dangerous-ws',   
    BASE_URL: '/dangerous-goods-web',
    CLIENT_ID: '0oa87bd95ptJmPPm64h7',
    OKTA_URL: 'https://login-dev.usps.gov/oauth2/aus51xxazjYoRO1Lv4h7/v1/authorize',
    CLIENT_SECRET: 'rju7_Zl7tohBZ97miq2BdCJ5qQ-_W9fr_1rad-7ZVQjguW5eftA3vP3fCZl_a6ff',
    ISSUER: 'https://login-dev.usps.gov/oauth2/aus51xxazjYoRO1Lv4h7',
    LOGIN: 'internal'
    // LOGIN: 'external' 
  }
  
  export default config